import {useEffect, useCallback} from "react"
import {useSelector} from "react-redux";

// import {useState} from "react"

const Tilt = (props) => {

    const panelData = useSelector(state => state.panelData);
    const accessible = useSelector(state => state.accessible);
    const animationCount = useSelector(state => state.animationCount);

    /** IOS Permissions... need a click. Like "Enter Site" button that was removed... **/

    // const [permissionGranted, setPermissionGranted] = useState(false);
    //
    // const permissionCallback = useCallback(()=>{
    //     if(!permissionGranted && accessible.siteEntered){
    //         if (typeof DeviceOrientationEvent.requestPermission === 'function') {
    //             DeviceOrientationEvent.requestPermission()
    //                 .then(permissionState => {
    //                     if (permissionState === 'granted') {
    //                         setPermissionGranted(true);
    //                         window.removeEventListener('click',permissionCallback)
    //                     }
    //                 })
    //                 .catch(console.error);
    //         } else {
    //             setPermissionGranted(true);
    //             window.removeEventListener('click',permissionCallback)
    //         }
    //     }
    //
    // }, [setPermissionGranted,permissionGranted,accessible.siteEntered])
    //
    // useEffect(()=>{
    //     window.addEventListener('click',permissionCallback)
    //     return ()=>window.removeEventListener('click',permissionCallback)
    // }, [permissionCallback])


    const tiltItems = useCallback((moveX,moveY)=>{
        let shift = .4;
        let backGround = props.backGround ? props.backGround.current : null;
        let extraBackGround = props.extraBackGround ? props.extraBackGround.current : null;
        let midGround = props.midGround ? props.midGround.current : null;
        let bonusGround = props.bonusGround ? props.bonusGround.current : null;

        if(backGround) {
            backGround.style.marginLeft =  Math.ceil(moveX)/5 + 'px';
            backGround.style.marginTop =  Math.ceil(moveY)/5 + 'px';
        }

        if(extraBackGround) {
            extraBackGround.style.transform = `translateX(${ (Math.ceil(moveX) * shift)}px) translateY(${(Math.ceil(moveY) * shift)}px)`
            shift = shift + .4;
        }

        if(midGround) {
            midGround.style.transform = `translateX(${ (Math.ceil(moveX) * shift)}px) translateY(${(Math.ceil(moveY) * shift)}px)`;
            shift = shift + .4;
        }

        if(bonusGround) {
            bonusGround.style.transform = `translateX(${ (Math.ceil(moveX) * shift)}px) translateY(${(Math.ceil(moveY) * shift)}px)`;
        }
    },[props])

    useEffect(()=>{

        if(window.DeviceMotionEvent && !accessible.exploring && animationCount === 0){

            const handleMotionEvent = event => {
                requestAnimationFrame(() =>{
                    tiltItems(event.gamma,event.beta)
                })
            };

            // window.addEventListener("deviceorientation", handleMotionEvent, false);

            return () => window.removeEventListener("deviceorientation", handleMotionEvent);
        }

    },[accessible.exploring, tiltItems, panelData, animationCount])


    return <></>;

}

export default Tilt;